




























import { FacingMode, State } from '@/store/modules/camera';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import FooterButton from '@/components/FooterButton.vue';

@Component({
  components: {
    FooterButton
  }
})
export default class CameraPageChangeCameraModeModal extends Vue {
  private onClick(event: Event): void {
    this.$emit('click', event);
  }
}
